/*
 * Figma `48:31` — KPI Card. Tone: Neutral, Positive, Warning, Danger.
 *
 * The tone is drawn as an edge rather than a fill, so a strip of four does not become four colour
 * blocks — and `meta` is not optional in spirit: a number with no sentence under it is the
 * decorative card the brief rules out. Every tile says what the figure means or what to do about it.
 */
import type { ReactNode } from 'react';

export type KpiTone = 'neutral' | 'positive' | 'warning' | 'danger';

export function KpiCard({ label, value, meta, tone = 'neutral', action }: {
  label: string;
  value: ReactNode;
  /** What the figure means, or what it is waiting on. */
  meta?: ReactNode;
  tone?: KpiTone;
  action?: ReactNode;
}) {
  return (
    <div className="jt-kpi" data-tone={tone}>
      <div className="jt-kpi-label">{label}</div>
      <div className="jt-kpi-value">{value}</div>
      {meta && <div className="jt-kpi-meta">{meta}</div>}
      {action}
    </div>
  );
}

export function KpiGrid({ children }: { children: ReactNode }) {
  return <div className="jt-kpi-grid">{children}</div>;
}
